import React, { useState } from 'react'
import config from '../../../config.json'
import ChooseWeekButtons from '../../general/ChooseWeekButtons'
import { AD, HIGHLIGHT, MOVIE, NEWSLETTER_IMAGE, NEWSLETTER_TEXT } from '../../../constants/itemTypes'
import SocialMedia from '../../general/SocialMedia'
import ListDropItems from '../../DragAndDropList/presents/ListDropItems'
import ListDrag from '../../DragAndDropList/presents/ListDrag'
import NewsletterDragDropItemSwitch from './NewsletterDragDropItemSwitch'
import MoviesFilterActionsContainer from '../../DragAndDropList/cont/MoviesFilterActionsContainer'
import ListDropConditionalWrapper from '../../DragAndDropList/presents/ListDropConditionalWrapper'
import ListToogleAllButtons from '../../DragAndDropList/presents/ListToogleAllButtons'


const filterConfig = [
    {
        id: 'genres',
        transId: 'movie_edit_movie_genres'
    },
    {
        id: 'technical',
        transId: 'section_filter_select_film_series_title_display'
    },
    {
        id: 'fsk',
        transId: 'movie_attributes_fsk'
    },
    {
        id: 'period',
        transId: 'section_filter_select_period_display_title'
    },
]


const getSelectedItems = (structureId, selectedItems) => selectedItems && selectedItems.hasOwnProperty(structureId) ? selectedItems[structureId] : []



// const conditionalWrapper = title => (children, display = true) => (
//     display ? (
//     <li className="periode-item-container">
//          {title && <div className="text-periode-date accordion-headline title-large-light">{title}</div>}
//         {children}
//     </li>
//     ) : ''
// )


const getType = type => {
    if('content' === type) {
        return AD
    } else if('highlights' === type )  {
        return HIGHLIGHT
    } else if('movies' === type) {
        return MOVIE
    } else {
        return type
    }
}

const NewsletterCampaignStructure = ({
    cinemaId,
    campaignId,
    structure,
    weeks,
    currentWeek,
    selectedItems,
    filteredItemsData,
    displayDropzones,
    canEditProgram,
    canEditNewsletter,
    updateWeek,
    addItem,
    reorderItem,
    deleteItem,
    deleteItemComplete,
}) => {
    const [isAllOpen, setAllOpen] = useState(true)

    const editBasePath = `${config.routes.newsletter.path}/campaign/${campaignId}`
    const params = {
        campaignId: campaignId
    }
    const displayDropzonesClass = displayDropzones ? ' dropzones' : ''



    let dragConfig = {
        order: ['content', 'highlights', NEWSLETTER_TEXT, NEWSLETTER_IMAGE, 'movies'],
        items: {
            content: {
                active: false,
                selected: [],
                titleTransId: "program_list_content_selection",
                buttonTextTransId: "program_list_button_new_content",
                className: 'content-content',
                itemType: AD,
                canEdit: true,
                canDelete: false,
                canAdd: true,
            },
            highlights: {
                active: false,
                selected: [],
                titleTransId: "program_list_highlight_selection",
                buttonTextTransId: "program_list_button_new_highlight",
                className: 'highlight-content',
                itemType: HIGHLIGHT,
                canEdit: true,
                canDelete: false,
                canAdd: true,
            },
            [NEWSLETTER_TEXT] : {
                active: false,
                selected: [],
                titleTransId: "print_flyer_text_elements_selection",
                buttonTextTransId: "print_flyer_new_text_element",
                className:'text-content',
                itemType: NEWSLETTER_TEXT,
                canEdit: true,
                canDelete: true,
                canAdd: true,
            },
            [NEWSLETTER_IMAGE] : {
                active: false,
                selected: [],
                titleTransId: "print_flyer_image_elements_selection",
                buttonTextTransId: "print_flyer_new_image_element",
                className:'image-content',
                itemType: NEWSLETTER_IMAGE,
                canEdit: true,
                canDelete: true,
                canAdd: true,
            },
            movies: {
                active: false,
                selected: [],
                titleTransId: "program_list_movie_selection",
                buttonTextTransId: null,
                className:'film-content',
                itemType: MOVIE,
                canEdit: true,
                canDelete: false,
                canAdd: false,
                moviesStructure: []
            },
        }
    }



    // useEffect(() => {
        structure.order.map(structureId => {
            const type = structure.items[structureId].itemType

            if(!dragConfig.order.includes(type)) {
                return 
            }

            if('movies' === type)  {
                dragConfig.items[type].moviesStructure.push(structure.items[structureId])
            }

            if(!dragConfig.items[type].active)  {
                dragConfig.items[type].active = true
                dragConfig.items[type].selected = getSelectedItems(structureId, selectedItems)
            } else {
                dragConfig.items[type].selected = _.union(  dragConfig.items[type].selected, getSelectedItems(structureId, selectedItems))
            }
        })

    // }, [structure, selectedItems])


    const canEdit = true //ToDO

    return (
        <div className="selections-item-content accordion-item">
            <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                <ListToogleAllButtons
                    setAllOpen={setAllOpen}
                />

                <div className="program-list film-content">
                    {dragConfig.order.map(type => {
                        const typeConfig = dragConfig.items[type]
                  
                        return (
                            typeConfig.active && <ListDrag
                                key={type}
                                titleTransId={typeConfig.titleTransId}
                                buttonTextTransId={typeConfig.buttonTextTransId}
                        
                                listId={type}
                                type={typeConfig.itemType}
                                order={filteredItemsData[type].filteredOrder}
                                items={filteredItemsData[type].filteredItems}
                                className={typeConfig.className}
                                ChildSwitchItem={NewsletterDragDropItemSwitch}
                                selected={typeConfig.selected}
                                params={params}

                                defaultIsOpen={isAllOpen}
                                setAllOpen={setAllOpen}
        
                                canEdit={typeConfig.canEdit}
                                canDelete={typeConfig.canDelete}
        
                                pathnameAdd={typeConfig.canAdd ? `${editBasePath}/${typeConfig.itemType}/addItem/form` : false}
                                deleteItem={typeConfig.canDelete ? deleteItemComplete : false}
                            >
                                {'movies' === type && <MoviesFilterActionsContainer
                                    filterConfig={filterConfig}
                                    listId="movies"
                                    dropStructureData={typeConfig.moviesStructure} 
                                    relevantAttributes={filteredItemsData.attributes}
                                    relevantMovies={filteredItemsData.movies.filteredOrder}
                                    currentMovies={filteredItemsData.movies.current}
                                    futureMovies={filteredItemsData.movies.future}
                                    selectedItems={selectedItems}
                                    addItem={(listId, itemId, targetId) => addItem(targetId, itemId)}
                                    deleteItem={(listId, itemId, targetId) => deleteItem(targetId, itemId)}
                                />}

                            </ListDrag>
                        )}
                    )}
                </div>
            </div>

            

            <div className={"selections-item-periodes section-right" + displayDropzonesClass}>
                <div className="periode-list">
                    <ul>
                        {structure.order.map((structureId) => {
                            const structureItem = structure.items[structureId]
                            const type = structureItem.itemType
                            const title = structureItem.headlineClient

                            return (
                                'week' === type && !displayDropzones ? (
                                    <li className="item-week" key={structureId}>
                                        <ChooseWeekButtons 
                                            weeks={weeks}
                                            activeWeek={currentWeek}
                                            updateWeek={updateWeek}
                                            isLink={false}
                                        />
                                    </li>
                                ) : (
                                    'content' === type ||
                                    'highlights' === type ||
                                    'movies' === type ||
                                    NEWSLETTER_TEXT === type ||
                                    NEWSLETTER_IMAGE === type
                                ) ? (
                                    <ListDropItems
                                        key={structureId}
                                        listId={structureId}
                                        title={title}
                                        conditionalWrapper={ListDropConditionalWrapper}
                                        order={getSelectedItems(structureId, selectedItems)}
                                        items={filteredItemsData[type].filteredItems}
                                        itemType={getType(type)}
                                        ChildSwitchItem={NewsletterDragDropItemSwitch}
                                        params={params}
                                        canEdit={canEditProgram}
                                        canDelete={canEditNewsletter}
                                        displayDropzones={displayDropzones}
                                        addItem={addItem}
                                        reorderItem={(oldIndex, newIndex) => reorderItem(structureId, oldIndex, newIndex)}
                                        deleteItem={(itemId) => deleteItem(structureId, itemId)}
                                    />
                                ) : 'social_media' === type && !displayDropzones ? (
                                    <SocialMedia
                                        key={structureId}
                                        className="periode-item-container"
                                        classNameTitle='text-periode-date accordion-headline title-large-light'
                                        classNameListWrapper='item-drag-container'
                                        classNameList='grid-container'
                                    />
                                // ) : NEWSLETTER_TEXT === type ? (
                                //     <ListDragItems
                                //         key={structureId}
                                //         listId={structureId}
                                //         title={title}
                                //         conditionalWrapper={conditionalWrapper}
                                //         campaignId={campaignId}
                                //         order={[]}
                                //         items={{}}
                                //         itemType={NEWSLETTER_TEXT}
                                //         canEdit={canEditProgram}
                                //         canDelete={canEditNewsletter}
                                //         displayDropzones={displayDropzones}
                                //         addItem={addItem}
                                //         reorderItem={reorderItem}
                                //         deleteItem={deleteItem}
                                //     />
                                // ) : NEWSLETTER_IMAGE === type ? (
                                //     <ListDragItems
                                //         key={structureId}
                                //         listId={structureId}
                                //         title={title}
                                //         conditionalWrapper={conditionalWrapper}
                                //         campaignId={campaignId}
                                //         order={[]}
                                //         items={{}}
                                //         itemType={NEWSLETTER_IMAGE}
                                //         canEdit={canEditProgram}
                                //         canDelete={canEditNewsletter}
                                //         displayDropzones={displayDropzones}
                                //         addItem={addItem}
                                //         reorderItem={reorderItem}
                                //         deleteItem={deleteItem}
                                //     />
                                // ) : 'social_media' === type ? (
                                //     <SocialMedia
                                //         key={structureId}
                                //         className="periode-item-container"
                                //         classNameTitle='text-periode-date accordion-headline title-large-light'
                                //         classNameListWrapper='item-drag-container'
                                //         classNameList='grid-container'
                                //     />
                                ) : ('')
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default NewsletterCampaignStructure